import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { orderService, inventoryService } from '../services/api';
import Navbar from '../components/Navbar';

const today = () => new Date().toLocaleDateString('en-CA');
const emptyItem = () => ({ articulo: '', descripcion: '', cantidad: 1, precio_unitario: '', tipo: '', tela_catalogo: '', tela_codigo: '' });
const TIPOS_MUEBLE = ['Sofá', 'Sofá cama', 'Sala / Juego de sala', 'Sillón / Reclinable', 'Butaca', 'Diván', 'Cama', 'Melamina', 'Colchón', 'Comedor', 'Zapatera de Hombre', 'Zapatera de Mujer', 'Cojines', 'Bancos con Tela', 'Coqueta', 'Juego de Comedor', 'Especial'];
const TIPOS_SIN_TELA = ['Melamina', 'Colchón', 'Zapatera de Hombre', 'Zapatera de Mujer'];
const emptyForm = () => ({ fechaOrden: today(), fechaEntrega: '', nombre: '', apellido1: '', apellido2: '', cedula: '', email: '', direccion: '', tel1: '', tel2: '', envio: 0, observaciones: '', esStock: false, mandadoPor: '', notaStock: '' });

export default function NewOrder() {
  const navigate = useNavigate();
  const [form, setForm] = useState(emptyForm());
  const [items, setItems] = useState([emptyItem()]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [catalog, setCatalog] = useState([]);
  const [showCatalog, setShowCatalog] = useState(null);
  const [buscandoCedula, setBuscandoCedula] = useState(false);
  const [cedulaMsg, setCedulaMsg] = useState('');
  const usuario = JSON.parse(localStorage.getItem('user') || '{}');
  const puedeStock = usuario.role === 'admin' || usuario.id === 9;

  useEffect(() => {
    inventoryService.getProducts().then(res => setCatalog(res.data)).catch(() => {});
  }, []);

  const set = k => e => setForm(p => ({ ...p, [k]: e.target.value }));

  const buscarCedula = async (cedula) => {
    const limpia = cedula.replace(/-/g, '').trim();
    if (!limpia || limpia.length < 9) return;
    setBuscandoCedula(true);
    setCedulaMsg('');
    try {
      const res = await fetch(`https://apis.gometa.org/cedulas/${limpia}`);
      const data = await res.json();
      const persona = data.results?.[0];
      if (persona) {
        setForm(p => ({ ...p, nombre: persona.firstname || '', apellido1: persona.lastname1 || '', apellido2: persona.lastname2 || '' }));
        setCedulaMsg('✅ Cliente encontrado');
      } else {
        setCedulaMsg('⚠ Cédula no encontrada');
      }
    } catch {
      setCedulaMsg('⚠ No se pudo consultar');
    } finally {
      setBuscandoCedula(false);
    }
  };

  const setItem = (idx, k) => e => {
    setItems(prev => prev.map((item, i) => i === idx ? { ...item, [k]: e.target.value } : item));
  };

  const addItem = () => setItems(prev => [...prev, emptyItem()]);

  const removeItem = idx => setItems(prev => prev.filter((_, i) => i !== idx));

  const selectFromCatalog = (idx, prod, vari) => {
    setItems(prev => prev.map((item, i) => i === idx
      ? { ...item, articulo: `${prod.name} - ${vari.nombre}`, precio_unitario: vari.precio }
      : item
    ));
    setShowCatalog(null);
  };

  const totalItems = items.reduce((sum, item) => sum + (Number(item.cantidad) * Number(item.precio_unitario || 0)), 0);
  const totalGeneral = totalItems + Number(form.envio || 0);

  const fmt = n => '₡' + Number(n).toLocaleString('es-CR');

  const handleSubmit = async () => {
    const req = form.esStock ? ['fechaOrden', 'fechaEntrega'] : ['fechaOrden', 'fechaEntrega', 'nombre', 'apellido1', 'direccion', 'tel1'];
    for (let f of req) {
      if (!form[f] || !form[f].toString().trim()) { setError('Completa todos los campos obligatorios (marcados con *). El nombre y el primer apellido son obligatorios.'); return; }
    }
    for (let item of items) {
      if (!item.tipo || !item.articulo || !item.cantidad || (!form.esStock && !item.precio_unitario)) {
        setError('Completa todos los campos de cada artículo (artículo, cantidad y precio).'); return;
      }
    }
    setLoading(true);
    try {
      let datos;
      if (form.esStock) {
        const obsStock = ['STOCK', form.mandadoPor ? 'Mando: ' + form.mandadoPor : '', form.notaStock || '', form.observaciones || ''].filter(Boolean).join(' - ');
        const itemsStock = items.map(it => ({ ...it, precio_unitario: 0 }));
        datos = { ...form, nombre: 'STOCK', apellido1: '', apellido2: '', cedula: '', email: '', direccion: 'STOCK', tel1: 'STOCK', envio: 0, observaciones: obsStock, items: itemsStock };
      } else {
        const nombreCompleto = [form.nombre, form.apellido1, form.apellido2].map(x => (x||'').trim()).filter(Boolean).join(' ');
        datos = { ...form, nombre: nombreCompleto, items };
      }
      await orderService.create(datos);
      alert('✅ Orden creada exitosamente');
      navigate('/dashboard');
    } catch (err) {
      setError('Error al crear la orden. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  const s = {
    main: { maxWidth: 860, margin: '0 auto', padding: '20px 14px' },
    card: { background: '#fff', borderRadius: 10, boxShadow: '0 1px 6px rgba(0,0,0,0.09)', padding: 24, marginBottom: 16 },
    label: { display: 'block', marginBottom: 4, fontWeight: 600, fontSize: 13, color: '#555' },
    input: { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 7, fontSize: 14, boxSizing: 'border-box', marginBottom: 12 },
    textarea: { width: '100%', padding: '9px 12px', border: '1px solid #ddd', borderRadius: 7, fontSize: 14, boxSizing: 'border-box', marginBottom: 12, resize: 'vertical', minHeight: 70 },
    grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 18px' },
    btnPrimary: { background: '#5c3d2e', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600 },
    btnSec: { background: '#f0ebe5', color: '#5c3d2e', border: 'none', padding: '10px 18px', borderRadius: 7, cursor: 'pointer', fontSize: 13, marginLeft: 8 },
    btnGhost: { background: 'transparent', color: '#5c3d2e', border: '1px solid #d0b89a', padding: '6px 12px', borderRadius: 7, cursor: 'pointer', fontSize: 12 },
    btnAdd: { background: '#f0fdf4', color: '#10b981', border: '1px dashed #10b981', padding: '8px 16px', borderRadius: 7, cursor: 'pointer', fontSize: 13, width: '100%', marginTop: 8 },
    btnRemove: { background: '#fee2e2', color: '#ef4444', border: 'none', padding: '6px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 12 },
    optional: { fontSize: 11, color: '#aaa', fontWeight: 400, marginLeft: 4 },
    itemRow: { background: '#fdf8f4', border: '1px solid #e8ddd4', borderRadius: 8, padding: 14, marginBottom: 10 },
    totalBox: { background: '#5c3d2e', color: '#fff', borderRadius: 8, padding: '14px 18px', marginTop: 12 },
  };

  return (
    <div style={{ fontFamily: "'Segoe UI',sans-serif", minHeight: '100vh', background: '#f8f5f0' }}>
      <Navbar />
      <div style={s.main}>

        {/* Datos del cliente */}
        <div style={s.card}>
          <h2 style={{ margin: '0 0 20px', color: '#5c3d2e', fontSize: 18 }}>➕ Nueva Orden</h2>

          <div style={s.grid2}>
            <div><label style={s.label}>Fecha de Orden *</label><input style={s.input} type="date" value={form.fechaOrden} onChange={set('fechaOrden')} /></div>
            <div><label style={s.label}>Fecha de Entrega *</label><input style={s.input} type="date" value={form.fechaEntrega} onChange={set('fechaEntrega')} /></div>
          </div>
          {puedeStock && (
            <div style={{ background: '#fff8ef', border: '1px solid #e0c9a6', borderRadius: 8, padding: 12, marginBottom: 12 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontWeight: 700, color: '#a0522d' }}>
                <input type="checkbox" checked={form.esStock} onChange={e => setForm(p => ({ ...p, esStock: e.target.checked }))} style={{ width: 18, height: 18 }} />
                📦 Es para stock (no es para un cliente)
              </label>
              {form.esStock && (
                <div style={{ marginTop: 10 }}>
                  <div><label style={s.label}>¿Quién la mandó a hacer? *</label><input style={s.input} placeholder="Ej: Pablo, Felix" value={form.mandadoPor} onChange={set('mandadoPor')} /></div>
                  <div><label style={s.label}>Nota <span style={s.optional}>(opcional)</span></label><input style={s.input} placeholder="Ej: para exhibición, reponer bodega" value={form.notaStock} onChange={set('notaStock')} /></div>
                </div>
              )}
            </div>
          )}


          {!form.esStock && (<>
          <div style={s.grid2}>
            <div>
              <label style={s.label}>Cédula <span style={s.optional}>(opcional)</span></label>
              <div style={{ position: 'relative', marginBottom: 4 }}>
                <input
                  style={{ ...s.input, marginBottom: 0, paddingRight: 44 }}
                  placeholder="1-0234-0567"
                  value={form.cedula}
                  onChange={set('cedula')}
                  onBlur={e => buscarCedula(e.target.value)}
                  autoComplete="off"
                  inputMode="numeric"
                />
                {buscandoCedula && (
                  <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 13, color: '#888' }}>
                    🔍
                  </span>
                )}
              </div>
              {cedulaMsg && (
                <div style={{ fontSize: 12, marginBottom: 8, color: cedulaMsg.startsWith('✅') ? '#10b981' : '#f59e0b', fontWeight: 600 }}>
                  {cedulaMsg}
                </div>
              )}
            </div>
            <div><label style={s.label}>Correo <span style={s.optional}>(opcional)</span></label><input style={s.input} type="email" placeholder="cliente@email.com" value={form.email} onChange={set('email')} /></div>
          </div>

          <div style={s.grid2}>
            <div><label style={s.label}>Nombre *</label><input style={{ ...s.input, background: buscandoCedula ? '#f5f5f5' : '#fff' }} placeholder="Nombre" value={form.nombre} onChange={set('nombre')} /></div>
            <div><label style={s.label}>1er Apellido *</label><input style={{ ...s.input, background: buscandoCedula ? '#f5f5f5' : '#fff' }} placeholder="Primer apellido" value={form.apellido1} onChange={set('apellido1')} /></div>
          </div>
          <div><label style={s.label}>2do Apellido <span style={s.optional}>(opcional)</span></label><input style={{ ...s.input, background: buscandoCedula ? '#f5f5f5' : '#fff' }} placeholder="Segundo apellido" value={form.apellido2} onChange={set('apellido2')} /></div>

          <div style={s.grid2}>
            <div><label style={s.label}>Teléfono 1 *</label><input style={s.input} placeholder="8888-1234" value={form.tel1} onChange={set('tel1')} autoComplete="off" inputMode="numeric" /></div>
            <div><label style={s.label}>Teléfono 2 <span style={s.optional}>(opcional)</span></label><input style={s.input} placeholder="Opcional" value={form.tel2} onChange={set('tel2')} /></div>
          </div>

          <label style={s.label}>Dirección *</label>
          <input style={s.input} placeholder="San José, Escazú, calle 5" value={form.direccion} onChange={set('direccion')} />
          </>)}
        </div>

        {/* Artículos */}
        <div style={s.card}>
          <h3 style={{ margin: '0 0 16px', color: '#5c3d2e', fontSize: 16 }}>📦 Artículos</h3>

          {items.map((item, idx) => (
            <div key={idx} style={s.itemRow}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                <span style={{ fontWeight: 600, fontSize: 13, color: '#5c3d2e' }}>Artículo {idx + 1}</span>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button style={s.btnGhost} onClick={() => setShowCatalog(showCatalog === idx ? null : idx)}>
                    🔍 Buscar en catálogo
                  </button>
                  {items.length > 1 && (
                    <button style={s.btnRemove} onClick={() => removeItem(idx)}>✕ Quitar</button>
                  )}
                </div>
              </div>

              {showCatalog === idx && (
                <div style={{ background: '#fff', border: '1px solid #e0d0c0', borderRadius: 8, padding: 12, marginBottom: 10 }}>
                  {catalog.length === 0
                    ? <p style={{ color: '#aaa', fontSize: 13 }}>No hay productos en el catálogo.</p>
                    : catalog.map(prod => (
                      <div key={prod.id} style={{ marginBottom: 8 }}>
                        <div style={{ fontWeight: 600, fontSize: 13, color: '#5c3d2e', marginBottom: 4 }}>{prod.name}</div>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                          {prod.variantes?.map(v => (
                            <button key={v.id} onClick={() => selectFromCatalog(idx, prod, v)}
                              style={{ background: v.stock === 0 ? '#fee2e2' : v.stock <= v.stockMin ? '#fef3c7' : '#f0fdf4', border: '1px solid #ddd', borderRadius: 6, padding: '5px 10px', cursor: v.stock === 0 ? 'not-allowed' : 'pointer', fontSize: 12 }}>
                              {v.nombre} — ₡{Number(v.precio).toLocaleString('es-CR')}
                              <span style={{ color: v.stock === 0 ? '#ef4444' : v.stock <= v.stockMin ? '#f59e0b' : '#10b981' }}> ({v.stock} uds)</span>
                            </button>
                          ))}
                        </div>
                      </div>
                    ))
                  }
                </div>
              )}

              <label style={s.label}>Tipo de mueble *</label>
              <select style={s.input} value={item.tipo} onChange={setItem(idx, 'tipo')}>
                <option value="">— Seleccionar tipo —</option>
                {TIPOS_MUEBLE.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
              <label style={s.label}>Artículo *</label>
              <input style={s.input} placeholder="Ej: Cama matrimonial, Closet 3 puertas..." value={item.articulo} onChange={setItem(idx, 'articulo')} />
              {item.tipo && !TIPOS_SIN_TELA.includes(item.tipo) && (
                <div style={s.grid2}>
                  <div>
                    <label style={s.label}>Catálogo de tela</label>
                    <input style={s.input} placeholder="Ej: Tokio" value={item.tela_catalogo} onChange={setItem(idx, 'tela_catalogo')} />
                  </div>
                  <div>
                    <label style={s.label}>Código de tela</label>
                    <input style={s.input} placeholder="Ej: 4521" value={item.tela_codigo} onChange={setItem(idx, 'tela_codigo')} />
                  </div>
                </div>
              )}

              <label style={s.label}>Descripción <span style={s.optional}>(opcional)</span></label>
              <input style={s.input} placeholder="Color, medidas, material, acabado..." value={item.descripcion} onChange={setItem(idx, 'descripcion')} />

              <div style={s.grid2}>
                <div>
                  <label style={s.label}>Cantidad *</label>
                  <input style={s.input} type="number" min="1" value={item.cantidad} onChange={setItem(idx, 'cantidad')} />
                </div>
                <div>
                  {!form.esStock && (<><label style={s.label}>Precio unitario (₡) *</label>
                  <input style={s.input} type="text" inputMode="numeric" placeholder="450000" value={item.precio_unitario} onChange={setItem(idx, 'precio_unitario')} /></>)}
                </div>
              </div>

              {item.precio_unitario && item.cantidad && (
                <div style={{ textAlign: 'right', fontSize: 13, color: '#5c3d2e', fontWeight: 600 }}>
                  Subtotal: {fmt(Number(item.cantidad) * Number(item.precio_unitario))}
                </div>
              )}
            </div>
          ))}

          <button style={s.btnAdd} onClick={addItem}>+ Agregar otro artículo</button>

          {/* Totales */}
          <div style={{ marginTop: 16 }}>
            <div style={s.grid2}>
              <div>
                {!form.esStock && (<><label style={s.label}>Flete / Envío (₡) <span style={s.optional}>(opcional)</span></label>
                <input style={s.input} type="number" placeholder="0" value={form.envio} onChange={set('envio')} /></>)}
              </div>
              <div></div>
            </div>
            <div style={s.totalBox}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13, opacity: 0.85 }}>
                <span>Subtotal artículos</span><span>{fmt(totalItems)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10, fontSize: 13, opacity: 0.85 }}>
                <span>Flete</span><span>{fmt(Number(form.envio || 0))}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 18, fontWeight: 700, borderTop: '1px solid rgba(255,255,255,0.3)', paddingTop: 10 }}>
                <span>TOTAL</span><span>{fmt(totalGeneral)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Observaciones */}
        <div style={s.card}>
          <label style={s.label}>Observaciones generales <span style={s.optional}>(opcional)</span></label>
          <textarea style={s.textarea} placeholder="Notas adicionales para la orden..." value={form.observaciones} onChange={set('observaciones')} />

          {error && <div style={{ color: '#c0392b', fontSize: 13, marginBottom: 12 }}>⚠ {error}</div>}

          <div>
            <button style={{ ...s.btnPrimary, opacity: loading ? 0.7 : 1 }} onClick={handleSubmit} disabled={loading}>
              {loading ? 'Creando...' : '✅ Crear Orden'}
            </button>
            <button style={s.btnSec} onClick={() => navigate('/dashboard')}>Cancelar</button>
          </div>
        </div>

      </div>
    </div>
  );
}
